/**
 * @fileoverview Date-picker change helpers for Reports login filters.
 * @module pages/reports/reportDateChange
 */
import dayjs from "dayjs";

/** Updates start/end date state and keeps the range consistent. */
export const handleReportDateChange = (date, dateType, ctx) => {
  if (dateType === "startDate") {
    if (!date) {
      ctx.setStartDate(null);
    } else {
      const formattedDate = date.format("YYYY-MM-DD");
      ctx.setStartDate(formattedDate);
      if (ctx.endDate && dayjs(ctx.endDate).isBefore(date, "day")) {
        ctx.setEndDate(formattedDate);
      }
    }
    ctx.setIsStartCalendarOpen(false);
    return;
  }

  if (dateType === "endDate") {
    if (!date) {
      ctx.setEndDate(null);
    } else {
      ctx.setEndDate(date.format("YYYY-MM-DD"));
    }
    ctx.setIsEndCalendarOpen(false);
  }
};
